module.exports = __webpack_public_path__ + "img/practice-3.aad7b689.jpg";